import React, { Fragment } from "react";
import setBodyColor from "../setBodyColor";
import DashboardItem from "../components/DashboardItem";

const Reports = () => {
  setBodyColor({ color: "white" });

  const dashboardItems = [
    { title: "Purchase Report", navigateTo: "/purchaseReport" },
    { title: "Sales Report", navigateTo: "/salesReport" },
    { title: "Payment Report", navigateTo: "/paymentReport" },
    { title: "Receipt Report", navigateTo: "/receiptReport" },
    { title: "Accounts Reports", navigateTo: "/accountsReports" },
  ];

  return (
    <Fragment>
      <div className="row text-center m-5">
        {dashboardItems.map((item, index) => (
          <DashboardItem
            key={index}
            title={item.title}
            navigateTo={item.navigateTo}
          />
        ))}
      </div>
    </Fragment>
  );
};

export default Reports;
